import { render, staticRenderFns } from "./layout-popup.vue?vue&type=template&id=982daa74&scoped=true"
import script from "./layout-popup.vue?vue&type=script&lang=js"
export * from "./layout-popup.vue?vue&type=script&lang=js"
import style0 from "./layout-popup.vue?vue&type=style&index=0&id=982daa74&prod&lang=scss&scoped=true"
import style1 from "./layout-popup.vue?vue&type=style&index=1&id=982daa74&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "982daa74",
  null
  
)

export default component.exports